module.exports = __webpack_public_path__ + "img/house-window.48288c68.svg";